import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';

// Register Polish locale for date formatting
registerLocaleData(localePl);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
